import createTableStore from "ds/components/Table/store/useTableStore";

import {
  SPACELIFT_VCS_REPOS_COLUMN_CONFIG,
  SPACELIFT_VCS_REPOS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useSpaceliftVcsReposTableStore = createTableStore({
  storageKey: SPACELIFT_VCS_REPOS_COLUMNS_STORAGE_KEY,
  config: SPACELIFT_VCS_REPOS_COLUMN_CONFIG,
  version: 2,
});

export default useSpaceliftVcsReposTableStore;
